module.exports = __webpack_public_path__ + "img/amex.e402ab1b.png";